import { render } from "./ProjectCard.vue?vue&type=template&id=99d0a4ca&scoped=true"
import script from "./ProjectCard.vue?vue&type=script&lang=js"
export * from "./ProjectCard.vue?vue&type=script&lang=js"

import "./ProjectCard.vue?vue&type=style&index=0&id=99d0a4ca&scoped=true&lang=css"

import exportComponent from "C:\\Development\\Portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99d0a4ca"]])

export default __exports__